import React, { useEffect, useState } from 'react';
import { useTranslation } from '../../../i18n';

const NotebookElement = ({
  element,
  isEditor = false,
  value = '',
  onChange,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const { content, style } = element;
  const {
    title = '',
    placeholder = '',
    fontFamily = 'Inter',
    fontSize = 20,
    lineHeight = 40,
    lineColor = '#3d3d3d',
    lineThickness = 2,
    textColor = '#1f2937',
  } = content || {};

  const backgroundColor = style?.backgroundColor || '#fdf6e3';

  const [localValue, setLocalValue] = useState(value || '');

  useEffect(() => {
    const external = value || '';
    if (disabled || isEditor) {
      setLocalValue(external);
      return;
    }
    setLocalValue(prev => {
      if (!prev && external) return external;
      if (external === '') return '';
      return prev;
    });
  }, [value, disabled, isEditor]);

  const handleChange = (e) => {
    if (isEditor || disabled) return;
    const v = e.target.value;
    setLocalValue(v);
    onChange?.(v);
  };

  // Draw the ruled line slightly below the natural text baseline so letters
  // sit a couple of millimetres above it — like handwriting on paper — instead
  // of the line cutting through descenders.
  const baselineY = Math.round((lineHeight + fontSize * 0.6) / 2) + 8;
  const lineStart = Math.max(0, baselineY - lineThickness);
  const linesBackground = `repeating-linear-gradient(
    to bottom,
    transparent 0px,
    transparent ${lineStart}px,
    ${lineColor} ${lineStart}px,
    ${lineColor} ${baselineY}px,
    transparent ${baselineY}px,
    transparent ${lineHeight}px
  )`;

  const effectivePlaceholder = placeholder || t('games.notebook.placeholder');
  const displayValue = isEditor ? '' : localValue;

  return (
    <div
      className="w-full h-full flex flex-col rounded-lg overflow-hidden"
      style={{ backgroundColor }}
    >
      {title && (
        <div
          className="px-4 pt-3 pb-1 font-medium"
          style={{ fontFamily, fontSize: Math.round(fontSize * 0.9), color: textColor }}
        >
          {title}
        </div>
      )}
      <div className="relative flex-1 min-h-0">
        <div
          className="absolute inset-0 pointer-events-none"
          style={{ backgroundImage: linesBackground }}
        />
        <textarea
          value={displayValue}
          onChange={handleChange}
          placeholder={effectivePlaceholder}
          disabled={isEditor || disabled}
          spellCheck={false}
          className="relative w-full h-full bg-transparent outline-none resize-none px-4"
          style={{
            fontFamily,
            fontSize,
            lineHeight: `${lineHeight}px`,
            color: textColor,
            paddingTop: 0,
            paddingBottom: 0,
            caretColor: textColor,
          }}
        />
      </div>
    </div>
  );
};

export default NotebookElement;
